














































































import { Vue, Component } from 'vue-property-decorator';
import { RateLimitResponse, RateLimit } from '@/controllers/api/types';
import { convertTimeStampToDateTime } from '@/utils/date';
import API from '@/controllers/api';

@Component
export default class RequestIndicator extends Vue {
  private isActive: boolean = false;
  private isCrashed: boolean = false;

  private get nextSearchRequest(): Date {
    return this.$store.state.requests.search.nextRequest || new Date();
  }

  private get nextProfileRequest(): Date {
    return this.$store.state.requests.profile.nextRequest || new Date();
  }

  private get searchCount(): number {
    return this.$store.state.requests.search.quantity;
  }
  private get profileCount(): number {
    return this.$store.state.requests.profile.quantity;
  }

  private handleActivation(): void {
    this.isActive = !this.isActive;
  }

  private async refreshRateLimit(): Promise<void> {
    try {
      const currentLimit: RateLimitResponse = await API.getRateLimit();
      const searchLimit: RateLimit = currentLimit.resources.search;
      const profileLimit: RateLimit = currentLimit.resources.core;

      this.$store.commit('setRequestCount', {
        type: 'search',
        reset: convertTimeStampToDateTime(searchLimit.reset),
        quantity: searchLimit.remaining,
      });

      this.$store.commit('setRequestCount', {
        type: 'profile',
        reset: convertTimeStampToDateTime(profileLimit.reset),
        quantity: profileLimit.remaining,
      });
    } catch (error) {
      this.isCrashed = true;
    }
  }

  private isRequestTimeIsUp(): boolean {
    const currentDate: Date = new Date();

    return (
      currentDate.getTime() > this.nextSearchRequest.getTime() ||
      currentDate.getTime() > this.nextProfileRequest.getTime()
    );
  }

  async mounted(): Promise<void> {
    this.refreshRateLimit();

    setInterval(async () => {
      if (this.isRequestTimeIsUp()) await this.refreshRateLimit();
    }, 5000);
  }
}
